import {
  ServiceDelayCheckRequest,
  ServiceDelayCheckResult
} from "@/domain/entities/ServiceDelay";

export type SdnResult = boolean | null;
export type SdnSide = "none" | "origin" | "destination" | "both";

type CheckSdn = (
  params: ServiceDelayCheckRequest
) => Promise<ServiceDelayCheckResult>;

export function bookingDistrictCode(district: unknown): string {
  if (!district || typeof district !== "object") return "";
  const code = (district as { code?: unknown }).code;
  return typeof code === "string" ? code.trim() : "";
}

export class BookingSdnState {
  origin: SdnResult = null;
  destination: SdnResult = null;
  private revision = 0;

  get side(): SdnSide {
    if (this.origin === true && this.destination === true) return "both";
    if (this.origin === true) return "origin";
    return this.destination === true ? "destination" : "none";
  }

  clear(): void {
    this.revision++;
    this.origin = null;
    this.destination = null;
  }

  async refresh(
    codes: { origin: string; destination: string },
    date: string,
    check: CheckSdn
  ): Promise<void> {
    this.clear();
    const revision = this.revision;
    if (!codes.origin || !codes.destination) return;
    try {
      const result = await check({
        originDistrictCode: codes.origin,
        destinationDistrictCode: codes.destination,
        startDate: date,
        endDate: date
      });
      if (revision !== this.revision) return;
      this.origin = result.isSdnOrigin;
      this.destination = result.isSdnDestination;
    } catch (error) {
      if (revision !== this.revision) return;
      console.error(
        "[booking-sdn] route check failed",
        error instanceof Error ? error.message : "Unknown error"
      );
      // Keep the route unknown on failure; booking remains available.
    }
  }
}
